import { render, staticRenderFns } from "./MediaVideo.vue?vue&type=template&id=f0a20ce2&scoped=true&"
import script from "./MediaVideo.vue?vue&type=script&lang=js&"
export * from "./MediaVideo.vue?vue&type=script&lang=js&"
import style0 from "./MediaVideo.vue?vue&type=style&index=0&id=f0a20ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a20ce2",
  null
  
)

export default component.exports